import { environment } from 'src/environments/environment';

let isRedirecting = false;

export function redirectToLogin(): void {
  if (isRedirecting) {
    return;
  }
  isRedirecting = true;
  localStorage.clear();
  window.location.replace(environment.loginAppUrl);
}
